<template>
  <div>
    <b-modal v-model="openModal" hide-header size="xl" @ok="insertOrUpdateMemberList($event)">
      <template>
        <table class="table table-sm table-bordered member__level__box">
          <tbody>
            <tr>
              <td class="level__box__title">會員等級名稱</td>
              <td>
                <div class="d-flex flex-column">
                  <input class="form-control" type="text" v-model="memberLevelList.name">
                  <ul class="level__box__example__list">
                    <li>
                      <small>例：鑽石會員</small>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr>
              <td class="level__box__title">總價再折扣</td>
              <td>
                <div class="w-100">

                  <b-form-radio-group v-model="memberLevelList.discountModel">
                    <b-form-radio value="percentage">折扣</b-form-radio>
                    <b-form-radio value="realNumber">折價</b-form-radio>
                  </b-form-radio-group>

                  <div class="w-100 d-flex align-items-center">
                    <span>此會員等級，結帳總金額再打</span>
                    <input class="form-control w-25" type="number"
                      v-model="memberLevelList.discountValue" />
                    <span>折</span>
                    <small>（例如：9）</small>
                  </div>

                  <ul class="level__box__example__list">
                    <li>
                      <small>數字，可小數以下兩位，不輸入表示無折扣</small>
                    </li>
                    <li>
                      <small>若某些商品不想打折，可於該商品編輯頁面折扣排除 P.S 勾選（不適用總價再折扣）</small>
                    </li>
                  </ul>


                  <div class="w-100 p-2 border">
                    <b-form-radio-group v-model="memberLevelList.discountType">
                      <b-form-radio value="nomalMember">適用一般會員</b-form-radio>
                      <b-form-radio value="generalPrice">
                        不適用一般價，訂單細目顯示
                        <span class="bg-warning text-danger">不適用再折扣</span>
                      </b-form-radio>
                      <b-form-radio value="memberPrice">
                        不適用會員價，訂單細目顯示
                        <span class="bg-warning text-danger">不適用再折扣</span>
                      </b-form-radio>
                    </b-form-radio-group>
                    <!-- <div>
                    <b-form-radio name="totalDis-radios" value="A">
                      適用一般會員
                    </b-form-radio>
                  </div>
                  <div class="d-flex">
                    <b-form-radio name="totalDis-radios" value="A">不適用一般價，訂單細目顯示</b-form-radio>
                    <span class="bg-warning text-danger">不適用總價再折扣</span>
                  </div>
                  <div class="d-flex">
                    <b-form-radio name="totalDis-radios" value="A">不適用會員價，訂單細目顯示</b-form-radio>
                    <span class="bg-warning text-danger">不適用總價再折扣</span>
                  </div> -->
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="level__box__title">折扣排除</td>
              <td>
                <div class="d-flex flex-column">
                  <div>
                    <b-form-checkbox v-model="memberLevelList.excludeSingle">不適用單品折扣
                    </b-form-checkbox>
                  </div>

                  <ul class="level__box__example__list">
                    <li>
                      <small>若某商品沒有單品折扣或折扣區時，本會員等級不適用單品折扣
                      </small>
                    </li>
                  </ul>

                  <div>
                    <b-form-checkbox v-model="memberLevelList.excludeFull">不適用滿額折扣
                    </b-form-checkbox>
                  </div>

                  <ul class="level__box__example__list">
                    <li>
                      <small>若您於
                        <strong class="text-danger">購物車設定</strong>
                        處有設定
                        <u class="text-danger">買滿多少打幾折</u>
                        時，本會員等級不適用
                        <u class="text-danger">買滿多少打幾折</u>
                      </small>
                    </li>
                  </ul>

                </div>
              </td>
            </tr>
            <tr>
              <td class="level__box__title">免運設定</td>
              <td>
                <div class="w-100">
                  <div class="d-flex align-items-center">
                    <span>當購物［金額］超過</span>
                    <input class="form-control w-25" v-model="memberLevelList.freightValue" />
                    <span>元時，免運費</span>
                  </div>

                  <ul class="level__box__example__list">
                    <li>
                      <small>此設定優先購物車設定處的（免運設定）</small>
                    </li>
                  </ul>

                </div>
              </td>
            </tr>
            <tr>
              <td class="level__box__title">計價方式</td>
              <td>
                <div class="w-100">
                  <b-form-radio-group v-model="memberLevelList.valuation.model"
                    @change="valuationChange()">
                    <div class="d-flex align-items-center">
                      <b-form-radio value="member">使用會員價計價</b-form-radio>
                      <b-form-checkbox class="text-danger ml-4"
                        v-model="memberLevelList.valuation.limit['member']">不允許看到一般價
                      </b-form-checkbox>
                    </div>

                    <ul class="level__box__example__list">
                      <li>
                        <small>此會員等級購物時，會使用會員價來計價</small>
                      </li>
                      <li>
                        <small>商品無會員價時，則使用一般價計價</small>
                      </li>
                    </ul>

                    <div class="d-flex align-items-center">
                      <b-form-radio value="normal">使用一般價計價</b-form-radio>
                      <b-form-checkbox class="text-danger ml-4"
                        v-model="memberLevelList.valuation.limit['normal']">不允許看到會員價
                      </b-form-checkbox>
                    </div>

                    <ul class="level__box__example__list">
                      <li>
                        <small>此會員等級購物時，會使用一般價來計價</small>
                      </li>
                      <li>
                        <small>通常較少使用此方式</small>
                      </li>
                    </ul>
                  </b-form-radio-group>
                </div>
              </td>
            </tr>
            <tr>
              <td class="level__box__title">升等金額</td>
              <td>
                <div class="w-100">
                  <div class="d-flex align-items-center">
                    <input class="form-control w-25" type="number"
                      v-model="memberLevelList.growValue" />
                    <span>元（選填）</span>
                  </div>

                  <ul class="level__box__example__list">
                    <li>
                      <small>當會員歷年累計購物金額達到此金額時，於會員列表會出限提是建議您該升級等此會員的等級</small>
                    </li>
                    <li>
                      <small>本功能僅是提示，不會自動升級該會員，您需手動做
                      </small>
                    </li>
                  </ul>

                </div>
              </td>
            </tr>
            <tr>
              <td class="level__box__title">消費限制</td>
              <td>
                <div class="w-100">
                  <div class="d-flex align-items-center">
                    <span>最低消費金額</span>
                    <input class="form-control w-25" type="number"
                      v-model="memberLevelList.limitPayMoney" />
                    <span>元</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <span>最低消費件數</span>
                    <input class="form-control w-25" type="number"
                      v-model="memberLevelList.limitPayCount" />
                    <span>件</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <template v-slot:modal-footer="{ok, close}">
        <div class="d-flex justify-content-end">
          <button class="btn btn-sm btn-primary" @click="ok()">儲存</button>
          <button class="btn btn-sm btn-danger ml-2" @click="close()">取消</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import ctrl from "./memberLevel.js"
  export default ctrl;

</script>

<style lang="scss">
  .member__level__box {
    .level__box__title {
      background-color: rgb(197, 197, 197);
      text-align: center;
      vertical-align: middle;
    }

    .level__box__example__list {
      padding: 0 0 0 20px;
      margin: 0;
    }
  }

</style>
